import {ref} from "vue";
import {auth} from "@/firebase/config";

let errorMessage = ref("");
let createAccount = async (inputEmail, inputPassword, inputName)=>{
    try {
        let res = await auth.createUserWithEmailAndPassword(inputEmail, inputPassword);
        res.user.updateProfile({
            displayName: inputName,
        });
        return res;
        if (!res){
            throw new Error("Can't Create New user");
        }
    }catch (e){
        errorMessage.value = e.message;
        console.log(errorMessage.value);
    }
}
let useSignUp = ()=>{
    return {errorMessage, createAccount};
}
export default useSignUp;